import { AmountCardTypeTokens, } from '@voltmoney/schema';
export const args = {
    title: 'Approved Cash List',
    subTitle: '30,000',
    message: 'Recomended to use as per limit',
    chipText: 'How?',
    warning: 'Recomended to use as per limit',
    progressLabel: '10% of total limit available',
    subscriptTitle: 'Out Of 30,000',
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(AmountCardTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
